import { render } from "./OrganisationSelector.vue?vue&type=template&id=5f1b445a&scoped=true"
import script from "./OrganisationSelector.vue?vue&type=script&lang=js"
export * from "./OrganisationSelector.vue?vue&type=script&lang=js"

import "./OrganisationSelector.vue?vue&type=style&index=0&id=5f1b445a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Documents\\LoesusPedagogia\\ArchiV2\\LP-Hub\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1b445a"]])

export default __exports__